import "@fontsource/baron-neue";
import "@fontsource/lato";

const GlobalStyle: React.FC = function GlobalStyleComponent() {
  return null;
};

export default GlobalStyle;